/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEvidenceType } from './CompetitionEvidenceType';
import {
    CompetitionEvidenceTypeFromJSON,
    CompetitionEvidenceTypeFromJSONTyped,
    CompetitionEvidenceTypeToJSON,
    CompetitionEvidenceTypeToJSONTyped,
} from './CompetitionEvidenceType';

/**
 * 
 * @export
 * @interface CompetitionMatchEvidence
 */
export interface CompetitionMatchEvidence {
    /**
     * 
     * @type {CompetitionEvidenceType}
     * @memberof CompetitionMatchEvidence
     */
    type: CompetitionEvidenceType;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchEvidence
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionMatchEvidence
     */
    uploadedAt: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchEvidence
     */
    uploadedBy?: string;
}



/**
 * Check if a given object implements the CompetitionMatchEvidence interface.
 */
export function instanceOfCompetitionMatchEvidence(value: object): value is CompetitionMatchEvidence {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    return true;
}

export function CompetitionMatchEvidenceFromJSON(json: any): CompetitionMatchEvidence {
    return CompetitionMatchEvidenceFromJSONTyped(json, false);
}

export function CompetitionMatchEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionMatchEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CompetitionEvidenceTypeFromJSON(json['type']),
        'url': json['url'],
        'uploadedAt': json['uploadedAt'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
    };
}

export function CompetitionMatchEvidenceToJSON(json: any): CompetitionMatchEvidence {
    return CompetitionMatchEvidenceToJSONTyped(json, false);
}

export function CompetitionMatchEvidenceToJSONTyped(value?: CompetitionMatchEvidence | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CompetitionEvidenceTypeToJSON(value['type']),
        'url': value['url'],
        'uploadedAt': value['uploadedAt'],
        'uploadedBy': value['uploadedBy'],
    };
}

